import React from 'react';
import { useProducts } from '../../context/ProductsContext';
import { ProductCard } from '../common/ProductCard';
import { Product } from '../../types/store';

interface BestSellersCarouselProps {
  onSelectProduct: (product: Product) => void;
  onViewAll?: () => void;
}

export const BestSellersCarousel: React.FC<BestSellersCarouselProps> = ({
  onSelectProduct,
  onViewAll,
}) => {
  const { products } = useProducts();
  const bestSellerProducts = products.filter((p) => !p.isBundle).slice(0, 4);

  return (
    <section id="best-sellers-section" className="py-10 sm:py-14 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="flex items-center justify-between gap-4 mb-6 sm:mb-8 pb-3 border-b border-slate-100">
          <div>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-black text-[#172554] tracking-tight">
              Best Selling MalRich Products
            </h2>
            <p className="text-xs sm:text-sm text-[#64748B] mt-0.5">
              Original MalRich weight gain milk powder & nutrition supplements at Health Store Pakistan with nationwide Cash on Delivery.
            </p>
          </div>

          {onViewAll && (
            <button
              onClick={onViewAll}
              className="text-xs sm:text-sm font-bold text-[#191975] hover:underline"
            >
              View All
            </button>
          )}
        </div>

        {/* 4 Columns Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {bestSellerProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onSelectProduct={onSelectProduct}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

